import React from 'react';
import { gql } from '@apollo/client';
import { Show } from 'react-admin';
import PositionRateSettingsShowActions from '../shared/position-rate-settings-show/PositionRateSettingsShowActions';
import PositionRateSettingsShow from '../shared/position-rate-settings-show/PositionRateSettingsShow';
import { generatePositionalRateSettingsShowViewQuery } from '../utils/generatePositionalRateSettingsQuery';

const MarketLocationTypePositionRateSettingShow = () => {
  return (
    <Show actions={<PositionRateSettingsShowActions />}>
      <PositionRateSettingsShow />
    </Show>
  );
};

MarketLocationTypePositionRateSettingShow.query = gql(
  generatePositionalRateSettingsShowViewQuery('market_location_type_position_rate_setting'),
);

export default MarketLocationTypePositionRateSettingShow;
